<template>
  <v-app>
      <menu-bar
      ></menu-bar>
      <v-navigation-drawer
          app
          permanent
          :rail="mini"
          color="secondary"
          style="margin-top: 1px">
        <main-side-menu @toggle="mini = !mini"></main-side-menu>
      </v-navigation-drawer>
      <messages-side-panel></messages-side-panel>
      <annotate-modal
          v-if="messages_open_asset_id"
          :asset_id="messages_open_asset_id"
          @close_modal="closeMessageAsset"
          @remove_item="closeMessageAsset"
      ></annotate-modal>
      <v-main style="padding-left: 65px; padding-top: 70px;">
            <v-snackbar-queue
                :items="snacks"
                @remove="() => {}"></v-snackbar-queue>
            <v-overlay
                id="v-page-loader"
                :model-value="loading"
                class="align-center justify-center"
                persistent
                scrim
            >
              <v-card
                v-if="progress != null"
                width="420"
                elevation="8"
                class="operation-progress-card"
              >
                <v-toolbar color="primary" dark density="compact">
                  <v-toolbar-title class="text-body-1">{{ progressLabel }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-4">
                  <div class="d-flex align-center">
                    <v-progress-circular
                      v-if="progress < 100 || progressRefreshing"
                      indeterminate
                      size="32"
                      width="3"
                      color="primary"
                      class="mr-3 flex-shrink-0"
                    />
                    <v-icon
                      v-else
                      color="success"
                      size="32"
                      class="mr-3 flex-shrink-0"
                    >
                      fas fa-check-circle
                    </v-icon>
                    <div class="flex-grow-1 min-width-0">
                      <v-progress-linear
                        :model-value="progress"
                        height="20"
                        rounded
                        color="primary"
                        class="mb-2"
                      />
                      <div class="d-flex justify-space-between align-center text-body-2">
                        <span
                          v-if="progressTotal > 0"
                          class="text-medium-emphasis"
                        >
                          {{ progressCountLabel }}
                        </span>
                        <span v-else></span>
                        <span class="font-weight-medium">{{ Math.round(progress) }}%</span>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
              <v-progress-circular
                  v-else
                  indeterminate
                  size="64"
              ></v-progress-circular>
            </v-overlay>
        <v-container fluid>
            <row v-if="title">
                <col12>
                    <v-card
                            elevation="2"
                    >
                        <v-card-title>
                            {{title}}
                        </v-card-title>
                        <v-card-subtitle v-if="subtitle">
                            {{subtitle}}
                        </v-card-subtitle>
                    </v-card>

                </col12>
            </row>
          <slot></slot>
        </v-container>
      </v-main>
    </v-app>
</template>

<script>
import MenuBar from "@/components/layout/MenuBar";
import MainSideMenu from "@/components/layout/MainSideMenu";
import Row from "@/components/layout/Row";
import Col12 from "@/components/layout/Col12";
import VSnackbarQueue from "@/components/SnacksQueue.vue";
import SnackbarsMixin from "@/mixins/SnackbarsMixin.vue";
import MessagesSidePanel from "@/components/MessagesSidePanel.vue";
import AnnotateModal from "@/components/AnnotateModal.vue";

export default {
  name: "MenuLayout",
  components: {VSnackbarQueue, Col12, Row, MainSideMenu, MenuBar, MessagesSidePanel, AnnotateModal},
  mixins: [SnackbarsMixin],
  props: {
    'loading': {default: false},
    'progress': {default: null},
    'progressLabel': {default: ''},
    'progressProcessed': {default: 0},
    'progressTotal': {default: 0},
    'progressRefreshing': {default: false},
    'title': {default: ''},
    'subtitle': {default: ''},
    'menu_items': {
      default: () => {
        return [
        {
          'name': 'Settings',
          'icon': 'fas fa-cog',
          'items': [
              {'name': 'Wallio'},
              {'name': 'Pieter pet'},
              {'name': 'Gekki'},
          ]
        }
      ]
      }
    },
  },
  data () {
    return {
      'mini': true,
      'snackbar': true,
    }
  },
  mounted() {
    document.title = 'BOX21'
  },
  computed: {
    messages_open_asset_id() {
      return this.$store.getters['messages/get_open_asset_id'];
    },
    progressCountLabel() {
      return this.$t('myassets.batch_assets_progress', {
        processed: this.progressProcessed,
        total: this.progressTotal,
      });
    },
  },
  methods: {
    select_item(item) {
      this.$emit('select_item', item);
    },
    closeMessageAsset() {
      this.$store.dispatch('messages/close_asset');
    },
  }
}
</script>

<style scoped>
.operation-progress-card {
  overflow: hidden;
}

.min-width-0 {
  min-width: 0;
}
</style>